// 背景
export const blackColor = '#26211E';
export const whiteColor = 'rgb(230, 233, 234)';
export const backWhiteColor = '#FFF5EE';
export const contentWrapColor = '#FFF5EE';
export const contentWrapTransColor = 'rgba(255, 245, 238, 0.6)';
// 文字
export const fontColorWhite = '#E6E9EA';
export const shadowBlackTxt = {
    color: blackColor,
    textShadowColor: 'rgba(55, 55, 55, 0.5)',
    textShadowOffset: {width: 2, height: 2},
    textShadowRadius: 4,
};
export const shadowWhiteTxt = {
    color: fontColorWhite,
    textShadowColor: 'rgba(0, 0, 0, 0.5)',
    textShadowOffset: {width: 2, height: 2},
    textShadowRadius: 4,
};


////////// 文字サイズ //////////
export const bigFontPc = '2.5rem';
export const bigFontSp= '1.5rem';
export const fontPc = '1.7rem';
export const fontSp= '1.1rem';
export const smallFontPc = '1.2rem';
export const smallFontSp= '0.8rem';

////////// ルート //////////
export const routeTop = '/';
export const routeTopJa = '/ja';
export const routeTermOfService = '/term_of_service';
export const routePrivacyPolicy = '/privacy_policy';
export const routeTokutei = '/tokutei';
export const routeContactPrepare = '/contact_prepare';
export const routeContact = '/contact';
export const routeContactDone = '/contact/done';